import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "os-plus",
  "use": "os-plus-usage",
  "viewBox": "0 0 16.113 16.123",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.113 16.123\" id=\"os-plus\"><path d=\"M0 8.057q0 .361.259.615t.61.254h6.319v6.318q0 .352.253.61.254.26.616.26.361 0 .62-.26.259-.258.259-.61V8.926h6.308q.352 0 .61-.254.26-.254.26-.615 0-.362-.26-.62-.258-.26-.61-.26H8.936V.87q0-.351-.26-.61Q8.419 0 8.057 0q-.36 0-.615.259-.253.259-.253.61v6.309H.869q-.351 0-.61.259Q0 7.695 0 8.057z\" fill=\"rgba(255,255,255,0.85)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol